export function getNonBillableTime(timeRegistered = 0, billableTimeRegistered = 0): number {
	const nonBillableTime = timeRegistered - billableTimeRegistered;
	return nonBillableTime;
}

/**
 * Resolves the `billableMinutesRegistered` value to send in a create/update time registration
 * mutation, given whether the target task/project is currently billable.
 *
 * When the target is non-billable we must send **no value at all — not even null**, so the
 * stored `time_reg_extension.billable_minutes_registered` stays NULL. The backend read path
 * (`TimeRegLogic`) only falls back to "all registered minutes are billable" when that column
 * is NULL; a stored literal `0` pins the entry at zero billable minutes permanently. That
 * stays invisible while the target is non-billable — the same read path reports 0 for
 * non-billable targets regardless of what is stored — and then silently surfaces as
 * unbillable time the moment the task or project is switched to billable.
 *
 * When the target is billable the caller's value is passed through untouched: `0` means the
 * user deliberately marked none of the time billable, and `null`/`undefined` means they never
 * touched the split, which the backend resolves to the full registered time.
 */
export function getBillableMinutesForMutation(
	targetEntityBillable: boolean,
	billableMinutes: number | null | undefined
): number | null | undefined {
	return targetEntityBillable ? billableMinutes : undefined;
}
